import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'react-router-redux';
import { Route, Switch } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';

import history from './history';
import store from './configureStore';
import App from './components/App';
import AuthWrapper from './components/AuthWrapper';
import Login from './components/pages/Login';
import i18n from './i18n';

render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <I18nextProvider i18n={ i18n }>
        <Switch>
          <Route path="/login" component={Login} />
          <AuthWrapper>
            <App />
          </AuthWrapper>
        </Switch>
      </I18nextProvider>
    </ConnectedRouter>
  </Provider>, document.getElementById('app')
);



// WEBPACK FOOTER //
// ./src/index.js